import React from 'react'
import PropTypes from 'prop-types'

const classNames = require('classnames')

import LeaguesTypeIcon from '../common/LeaguesTypeIcon'
import { GlgTextInput } from 'Shared/components'
import useSessionSaver from '../../hooks/useSessionSaver'

const LeaguesRenameRow = ({ league, index }) => {
  const { updateNameForLeague } = useSessionSaver()

  return (<tr className={classNames({
    'cls-lr-regular-row': true,
    'cls-lr-regular-row-highlighted': league.name !== league.league_name,
  })}>
    <td className={'cls-lr-tdata'}>{index + 1}</td>
    <td className={'cls-lr-tdata'}>{league.name}</td>
    <td className={'cls-lr-tdata'}>{league?.first_round?.playAt}</td>
    <td className={'cls-lr-tdata'}>{league?.last_round?.playAt}</td>
    <td className={'cls-lr-tdata'}>
      <GlgTextInput
        onChange={(value) => updateNameForLeague(league.id, value)}
        value={league.league_name}
        debounceSpan={500}
        placeholder={league.league_name}
      />
    </td>
    <td className={'cls-lr-tdata'}>
      <LeaguesTypeIcon leagueType={league.product}/>
    </td>
  </tr>)
}

LeaguesRenameRow.propTypes = {
  league: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    league_name: PropTypes.string.isRequired,
    first_round: PropTypes.shape({
      playAt: PropTypes.string,
    }),
    last_round: PropTypes.shape({
      playAt: PropTypes.string,
    }),
    product: PropTypes.string.isRequired,
  }),
  index: PropTypes.number.isRequired,
}
export default LeaguesRenameRow
